module.exports = "<mat-card>\r\n\t<mat-card-title>\r\n\t\t<h2>{{title|translate}}</h2>\r\n\t</mat-card-title>\r\n</mat-card>\t"